import {
  COUNTRY_PREVIEW,
  COUNTRY_NEW,
  COUNTRY_UPDATE,
  COUNTRY_REMOVE,
  COUNTRY_PROCESS_SUCCESS,
  COUNTRY_DATASOURCE_SUCCESS,
  COUNTRY_SEARCH,
  COUNTRY_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case COUNTRY_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case COUNTRY_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case COUNTRY_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case COUNTRY_REMOVE: {
      return {
          ...state,
          loader: false
      }
    }
    case COUNTRY_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case COUNTRY_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process: action.payload
      }
    }
    case COUNTRY_DATASOURCE_SUCCESS:{
      return {
        ...state,
        loader: false,
        dataSource: action.payload
      }
    }
    case COUNTRY_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}